// FILE: src/Components/Dashboard.js
import React, { Suspense, lazy } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spin } from "antd";
import Sidebar from "./Sidebar";
import Header from "./Header";
// import OnboardingChecklist from "./Dashboard/OnboardingChecklist";
// import SignalsFeed from "./Dashboard/SignalsFeed";
import CopilotHome from "./Copilot/CopilotHome";
import UpgradeModal from "./BuySubscription/UpgradeModal";

const Calender = lazy(() => import("./Calender"));
const QueuePage = lazy(() => import("./QueuePage"));
const PublishPage = lazy(() => import("./PublishPage"));
const MediaLibrary = lazy(() => import("./Assets/MediaLibrary"));
const BrandKit = lazy(() => import("./BrandKit"));
const GroupsProfile = lazy(() => import("./GroupsProfile"));
const AccountSetting = lazy(() => import("./AccountSetting"));
const CreateCampagin = lazy(() => import("./CreateCampagin"));
const Inbox = lazy(() => import("./Inbox"));
const Message = lazy(() => import("./Message"));
const Konvatest = lazy(() => import("./Konvatest"));
const LinksDashboard = lazy(() => import("./Publishing/LinksDashboard"));
const ProfileReports = lazy(() => import("./Reports/ProfileReports"));
const PostReports = lazy(() => import("./Reports/PostReports"));
const AEOPage = lazy(() => import("./SEO/AEOPage"));
const ContentPage = lazy(() => import("./SEO/ContentPage"));
const BlogEditorPage = lazy(() => import("./SEO/BlogEditorPage"));
const AiBlogWorkflowPage = lazy(() => import("./SEO/AiBlogWorkflowPage"));
const SeoSettingsPage = lazy(() => import("./SEO/SeoSettingsPage"));

const AppsDashboard = lazy(() => import("./Apps/AppsDashboard"));
const BackgroundRemoverApp = lazy(() => import("./Apps/BackgroundRemoverApp"));
const CaptionGeneratorApp = lazy(() => import("./Apps/CaptionGeneratorApp"));
const AppsHistory = lazy(() => import("./Apps/AppsHistory"));
const ImageUpscalerApp = lazy(() => import("./Apps/ImageUpscalerApp"));
const MoodboardApp = lazy(() => import("./Apps/MoodboardApp"));
const ImageGeneratorApp = lazy(() => import("./Apps/ImageGeneratorApp"));
const ImageColorPaletteApp = lazy(() => import("./Apps/ImageColorPaletteApp"));
const ImageResizerApp = lazy(() => import("./Apps/ImageResizerApp"));
const ImageColorGradeApp = lazy(() => import("./Apps/ImageColorGradeApp"));
const CarouselMakerApp = lazy(() => import("./Apps/CarouselMakerApp"));

const AppRouteFallback = () => (
  <div className="flex h-full min-h-[60vh] items-center justify-center bg-gray-50">
    <Spin size="large" />
  </div>
);

const DashboardContent = () => (
<div className="min-h-full bg-gray-50">
<CopilotHome />
</div>
);

const SeoProtectedRoute = ({ children }) => {
const navigate = useNavigate();
const { subscription } = useSelector((state) => state.subscription);
const seoEnabled = subscription?.plan?.seo_enabled === true;

if (seoEnabled) {
return children;
}

return (
<UpgradeModal
isOpen={true}
onClose={() => navigate("/Dashboard", { replace: true })}
featureName="SEO"
message="The SEO panel is not included in your current plan. Please upgrade to access SEO Content and Settings."
/>
);
};

export default function Dashboard() {
  return (
    <div className="flex h-screen bg-gray-50">
      <div className="w-64 flex-shrink-0">
        <Sidebar />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 overflow-y-auto">
          <Suspense fallback={<AppRouteFallback />}>
            <Routes>
              <Route path="/" element={<DashboardContent />} />

              <Route path="/Publishing" element={<Calender />} />
              <Route path="/QueuePage" element={<QueuePage />} />
              <Route path="/PublishPost" element={<PublishPage />} />
              <Route path="/Links" element={<LinksDashboard />} />

              <Route path="/Apps" element={<AppsDashboard />} />
              <Route path="/Apps/background-remover" element={<BackgroundRemoverApp />} />
              <Route path="/Apps/caption-generator" element={<CaptionGeneratorApp />} />
              <Route path="/Apps/history" element={<AppsHistory />} />
              <Route path="/Apps/image-color-palette" element={<ImageColorPaletteApp />} />
              <Route path="/Apps/image-upscaler" element={<ImageUpscalerApp />} />
              <Route path="/Apps/image-resizer" element={<ImageResizerApp />} />
              <Route path="/Apps/image-color-grade" element={<ImageColorGradeApp />} />
              <Route path="/Apps/carousel-maker" element={<CarouselMakerApp />} />
              <Route path="/Apps/moodboard" element={<MoodboardApp />} />
              <Route path="/Apps/image-generator" element={<ImageGeneratorApp />} />

              <Route path="/Assets" element={<MediaLibrary />} />
              <Route path="/BrandKit" element={<BrandKit />} />
              <Route path="/GroupsProfile" element={<GroupsProfile />} />
              <Route path="/AccountSetting" element={<AccountSetting />} />
              <Route path="/ProfileReports" element={<ProfileReports />} />
<Route path="/PostReports" element={<PostReports />} />

<Route path="/SEO/AEO" element={<SeoProtectedRoute><AEOPage /></SeoProtectedRoute>} />
<Route path="/SEO/Content" element={<SeoProtectedRoute><ContentPage /></SeoProtectedRoute>} />
<Route path="/SEO/Settings" element={<SeoProtectedRoute><SeoSettingsPage /></SeoProtectedRoute>} />
<Route path="/SEO/Content/new" element={<SeoProtectedRoute><BlogEditorPage /></SeoProtectedRoute>} />
<Route path="/SEO/Content/write-ai" element={<SeoProtectedRoute><AiBlogWorkflowPage /></SeoProtectedRoute>} />
<Route path="/SEO/Content/:blogId" element={<SeoProtectedRoute><BlogEditorPage /></SeoProtectedRoute>} />
              <Route path="/Inbox" element={<Inbox />} />
              <Route path="/Campagin" element={<CreateCampagin />} />
              <Route path="/Message" element={<Message />} />
              <Route path="/Konva" element={<Konvatest />} />

              <Route path="*" element={<Navigate to="/Dashboard" replace />} />
            </Routes>
          </Suspense>
        </main>
      </div>
    </div>
  );
}